<template>
  <div class="relative items-center">
    <div class="font-heavy mb-2">{{ title }}</div>
    <div>{{ subtitle }}</div>
  </div>
</template>

<script>
import BaseLogo from './BaseLogo.vue';

export default {
  name: 'BaseFormPartHeader',
  components: {
    BaseLogo,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.custom-position {
  right: calc(100%);
  width: 55px;
  height: 55px;
}
</style>
